import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
export const APP_ROUTES: Routes = [
    {
        path: '',
        loadChildren: '@my/my.module#MyModule'
    },
    // {
    //     path: 'my',
    //     loadChildren: '@my/my.module#MyModule'
    // },
    {
        path: 'id',
        loadChildren: '@id/id.module#IdModule'
    },
    {
        path: 'ph',
        loadChildren: '@ph/ph.module#PhModule'
    },
    {
        path: 'vn',
        loadChildren: '@vi/vi.module#ViModule'
    }
];
@NgModule({
    imports: [RouterModule.forRoot(APP_ROUTES, {
        enableTracing: false,
        useHash:false
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts